export const name = 'LocalStorageService';

import { useMainStore } from '@/stores/main'

export function isWorking()
{
  if (typeof(Storage) !== "undefined") {
    return true;
  } else {
    console.error("No localStorage support on this browser!");
    return false;
  }
}

export function get(key)
{
  if (!isWorking()){
    return;
  }
  return JSON.parse(localStorage.getItem(key));
}

export function set(key, value)
{
  if (!isWorking()){
    return;
  }
  localStorage.setItem(key, JSON.stringify(value));
}

export function loadState()
{
  const store = useMainStore()
  let state = get('state');
  if (!state){
    return;
  }
  for (var key in state){
    // An array (permissions, roles) has to come back as an array: spread into braces it would
    // become an object and every includes() written on it would blow up.
    store[key] = Array.isArray(state[key]) ? [...state[key]] : {...state[key]}
  }
}

export function saveState()
{
  // Permissions and roles are kept with the session: the router guard needs them as soon as the
  // app starts, while the refresh of GET /api/user that updates them (Auth.refreshUser) is still
  // on its way. Same staleness the user object already has, and the server is the real gate.
  const toSave = [
    'auth',
    'permissions',
    'roles',
    'settings'
  ]
  const store = useMainStore()
  let newState = {};
  for (let i in toSave){
    let key = toSave[i]
    newState[key] = Array.isArray(store[key]) ? [...store[key]] : {...store[key]}
  }
  set('state', newState);
}
